import {
  Popover,
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { CustomButton } from "../../../components/RosterConfig/RosterConfigStyle";
import classes from "../OMTBulkEdit/Common.module.css";

export default function ColumnFilterPopover({
  anchorEl,
  onClose,
  options,
  selectedValues,
  onToggle,
  onClear,
}) {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <Box sx={{ p: 1.5, minWidth: 220 }}>
        {options.length > 0 && (
          <Typography
            variant="h6"
            sx={{
              mb: 2,
              fontFamily: "Urbanist, sans-serif",
              fontWeight: "bold",             
              color: "#3F5765",
            }}
          >
            Filter Trainee Status
          </Typography>
        )}
        {options.length === 0 ? (
          <Box sx={{ px: 1, py: 0.5 }}>No values available</Box>
        ) : (
          options.map((opt) => (
            <FormControlLabel
              key={opt}
              sx={{ display: "flex", ml: 0 }}
              control={
                <Checkbox
                  size="small"
                  checked={selectedValues.includes(opt)}
                  onChange={() => onToggle(opt)}
                />
              }
              label={opt}
            />
          ))
        )}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <CustomButton
            variant="contained"
            className={classes.buttonSave}
            size="small"
            onClick={onClose}
          >
            Apply
          </CustomButton>
          <CustomButton
            variant="outlined"
            className={classes.buttonReset}
            size="small"
            onClick={onClear}
          >
            Clear
          </CustomButton>
        </Box>
      </Box>
    </Popover>
  );
}
